

























































































































import { Vue, Component } from 'vue-property-decorator';
import { RouteNames } from './_routes';

import { Subscription } from 'vue-rx-decorators';
import { Cache } from '../../common/cache';
import { alert } from '@/common/modal';

import { Facility } from '@lantern/facility-sdk';
import { Facilities, User, InmateSource, CanvasAccounts } from '@lantern/lantern-sdk';

// hierarhy select
// @ts-ignore
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export enum ManageRoutNames {
    AddNewFacility = 'Add Facility',
    DeleteFacility = 'Delete Facility',
    AddFacilitiesToAccount = 'Access Control',

}

interface FacilitiesCheck extends Facilities.Document{
    selected: boolean;
    jpayEnrollment: boolean; // flag that indicates that we going to use a password for Jpay inmates
}

interface FacilitiesToAccount extends Facilities.Document{
    selected: boolean;
    added: boolean;
    singleStudents: boolean; // allowed user to see list of inmates or register them only by name and id
    connectedTo: number | null; // use this var to check if document canvasAccount was created for this account. number - document already exist. Null - creat a new CanvasAccount first
}

interface FacilityAddCheck extends Facility {
    selected: boolean;
    added: boolean;
    jpayEnrollment: boolean; // flag that indicates that we going to use a password for Jpay inmates
}

interface Children {
    id: string;
    label: string;
    children: Children[];
}

@Component({
    components: { Treeselect }
})
export default class ManageAccessComponent extends Vue {

    currentRouteName: ManageRoutNames = ManageRoutNames.AddNewFacility;
    addNewFacility: ManageRoutNames = ManageRoutNames.AddNewFacility;
    deleteFacility: ManageRoutNames = ManageRoutNames.DeleteFacility;
    AddFacilitiesToAccount: ManageRoutNames = ManageRoutNames.AddFacilitiesToAccount;

    source: InmateSource | null = null;
    svis: InmateSource.svis = InmateSource.svis;
    jpay: InmateSource.jpay = InmateSource.jpay;

    loader = false;

    accountSelected: string = 'Please select an account';

    facilities: FacilitiesCheck[] | null = null;
    facilitiesToAdd: FacilityAddCheck[] | null = null;
    facilitiesToAccount: FacilitiesToAccount[] | null = null;

    routerNames = RouteNames;

    links: { route: ManageRoutNames }[] = [
        {
            route: ManageRoutNames.AddNewFacility,
        },
        {
            route: ManageRoutNames.DeleteFacility,
        },
        {
            route: ManageRoutNames.AddFacilitiesToAccount,
        },
    ]

    accountHierarchical: { id: string; label: string; children: Children[]}[] = []

    @Subscription(() => Cache.instance.accounts)
    accounts!: User.CanvasAccounts | {mainAccounts: string[]; subAcccounts: string[]};

    async created() {
        try {
            await this.getFacilities();

        } catch (error: any) {
            await alert(error.message); // TODO

        }

        if (this.accounts.mainAccounts.length === 0) {
            const response = await this.$lantern.endpoints.User.getAccounts();

            const accounts = response.data;
            this.$cache.accounts.next(accounts);
        }

        // create accounts Hierarchy
        this.accounts.mainAccounts.forEach((element: string) => {
            const [id, name, parentId] = element.split(':');
            const label = `${id} - ${name}`;
            this.accountHierarchical.push({ id, label, children: [] });
        });

        this.accounts.subAcccounts.forEach((element: string) => {
            const [id, name, parentId] = element.split(':');
            const label = `${id} - ${name}`;
            this.accountHierarchical.forEach((subElement: { id: string; label: string; children: Children[]}) => {
                if (subElement.id === parentId) {
                    subElement.children.push({
                        id,
                        label,
                        children: []
                    });
                } else {
                    this.checkAcountChildren(subElement, id, label, parentId);
                }
            });
        });
    }

    // create accounts Hierarchy util
    checkAcountChildren(subElement: { id: string; label: string; children: Children[]}, id: string, label: string, parentId: string) {
        subElement.children.forEach(element => {
            if (element.id === parentId) {
                element.children.push({
                    id,
                    label,
                    children: []
                });
            } else {
                this.checkAcountChildren(element, id, label, parentId);
            }
        });

    }

    // #region LOAD FACILITY
    async loadallFacilities(source: InmateSource) {

        if (this.loader) return;

        try {
            this.loader = true;
            this.facilitiesToAdd = null;
            const response = await this.$lantern.endpoints.Facilities.all({ inmateSource: source });

            // this.facilities - added to Dynamo Faciliries
            if (!this.facilities) return;

            this.facilitiesToAdd = response.data.items.map(el => {
                let added = false;
                let jpayEnrollment = false;
                this.facilities!.forEach(element => {
                    if (element.id === `${source}:${el.id}`) added = true;
                    if (element.id === `${source}:${el.id}` && element.jpayEnrollment) jpayEnrollment = true;
                });
                return { ...el, selected: added, added, jpayEnrollment }; // TODO check facility
            }).sort((a, b) => <any>a.added - <any>b.added);
            this.loader = false;

        } catch (error: any) {
            await alert(`Connection Error! Message: ${error.message}`);
            this.loader = false;
        }
    }

    async addFacility(facilityId: string, displayName: string, jpayEnrollment: boolean) {

        const createFacilityParams: any /* : Parameters<typeof Facilities.create>[0]*/ = {
            inmateSource: this.source!,
            facilityId,
            displayName,
            importEnabled: true,
            canvasAccountId: parseInt(this.accounts.mainAccounts[0], 10),
            jpayEnrollment,
            createdBy: this.$cache.user.value!.id
        };

        try {
            const responce = await this.$lantern.endpoints.Facilities.create({ ...createFacilityParams });
            await this.getFacilities();
            await alert(`Facility with id: ${facilityId} was created successfully`);
            if (this.source) await this.loadallFacilities(this.source);

        } catch (error) {
            await alert(`Error! Facility wasn't created`);
        }
    }
    // #endregion LOAD FACILITY PART

    // #region DELETE FACILITY
    async getFacilities() {

        try {
            const svisPro = this.$lantern.endpoints.Facilities.list({ inmateSource: InmateSource.svis });
            const jpayPro = this.$lantern.endpoints.Facilities.list({ inmateSource: InmateSource.jpay });
            const responseAll = await Promise.all([svisPro, jpayPro]);
            const facilities = [...responseAll[0].data.items, ...responseAll[1].data.items];
            this.facilities = facilities.map(el => {
                return { ...el, selected: false };
            });

        } catch (error: any) {
            await alert(error.message);
        }

    }

    async removeFacility(id: string) {
        try {
            await this.$lantern.endpoints.Facilities.remove(id);
            await alert(`Facility with id: ${id} was removed successfully`);

        } catch (error) {
            await alert(`Error! Facility wasn't removed`);
        }

        await this.getFacilities();
    }
    // #endregion DELETE FACILITY

    // #region FACILITY TO ACCOUNT
    async getAccountFacilities() {

        if (this.accountSelected === undefined) {
            this.facilitiesToAccount = null;
            return;
        }

        // if canvasAccount exist - show all facilities and mark conected
        this.facilitiesToAccount = null;
        try {
            const response = await this.$lantern.endpoints.CanvasAccounts.get(this.accountSelected);
            const addedFacilities: any = response.data.facilities;

            if (this.facilities) {
                this.facilitiesToAccount = this.facilities.map(element => {
                    let added = false;
                    let singleStudents = false;
                    // const jpayEnrollment = false; // TODO
                    // use this var to check if document canvasAccount was created for this account
                    const connectedTo = response.data.canvasAccountId;
                    addedFacilities.forEach((addedElement: { id: string; registrationAccessMode: string }) => {
                        if (addedElement.id === element.id) added = true;
                        if (addedElement.id === element.id && addedElement.registrationAccessMode === CanvasAccounts.RegistrationAccessMode.singleStudents) singleStudents = true;
                    });

                    // if (element.registrationAccessMode)
                    return { ...element, added, connectedTo, selected: added, singleStudents };
                });
            }

        } catch (error: any) {
            if (error.isAxiosError) {

                // if canvasAccount doesn't exist yet, show list with all facilities which could be added to this account
                if (error.response.status === 404) {

                    if (this.facilities) {
                        this.facilitiesToAccount = this.facilities.map(element => {
                            return { ...element, added: false, connectedTo: null, singleStudents: false };
                        });
                    }
                }
            }
        }

    }

    createAccountParams(facility: FacilitiesToAccount, deleteMode: boolean) {
        let data;

        if (deleteMode) {
            const facilities = this.facilitiesToAccount?.map(element => {
                if (facility.id !== element.id && element.added) return { id: element.id, registrationAccessMode: element.singleStudents ? CanvasAccounts.RegistrationAccessMode.singleStudents : CanvasAccounts.RegistrationAccessMode.multipleStudents };
                return null;
            }).filter(element => !!element?.id) as [{id: string}] | [];

            data = {
                canvasAccountId: Number(this.accountSelected),
                facilities: [...facilities]
            };

        } else {
            const curentFacility: {id: string; registrationAccessMode: CanvasAccounts.RegistrationAccessMode} = { id: facility.id, registrationAccessMode: facility.singleStudents ? CanvasAccounts.RegistrationAccessMode.singleStudents : CanvasAccounts.RegistrationAccessMode.multipleStudents };
            const facilities = this.facilitiesToAccount?.map(element => {
                if (element.added) return { id: element.id, registrationAccessMode: element.singleStudents ? CanvasAccounts.RegistrationAccessMode.singleStudents : CanvasAccounts.RegistrationAccessMode.multipleStudents };
                return null;
            }).filter(element => !!element?.id) as {id: string; registrationAccessMode: CanvasAccounts.RegistrationAccessMode}[] | [];

            // update mode
            if (!(facility.added && facility.selected)) (facilities as {id: string; registrationAccessMode: CanvasAccounts.RegistrationAccessMode}[]).push(curentFacility);

            data = {
                canvasAccountId: Number(this.accountSelected),
                facilities: [...facilities]
            };
        }

        return data;
    }

    async addFacilityToAccount(facility: FacilitiesToAccount) {

        // if CanvasAccount document wasn't created yet - create it
        if (facility.connectedTo === null) {

            const createAccountParams: Parameters<typeof CanvasAccounts.create>[0] = {
                canvasAccountId: Number(this.accountSelected),
                facilities: [
                    {
                        id: facility.id,
                        registrationAccessMode: facility.singleStudents ? CanvasAccounts.RegistrationAccessMode.singleStudents : CanvasAccounts.RegistrationAccessMode.multipleStudents,
                    }
                ]
            };

            try {
                const response = await this.$lantern.endpoints.CanvasAccounts.create({ ...createAccountParams });
                await alert(`Records were updated successfully`);
                await this.getAccountFacilities();

            } catch (error) {
                await alert(`Error! Cannot create Lantern account record!`);
            }
        } else {
            const editeParams = this.createAccountParams(facility, false);

            try {

                const response = await this.$lantern.endpoints.CanvasAccounts.update(editeParams.canvasAccountId.toString(), { facilities: [...editeParams.facilities] });
                await alert(`Records were updated successfully`);
                await this.getAccountFacilities();

            } catch (error) {
                await alert(`Error! Cannot create Lantern account record!`);
            }
        }

    }

    async removeFacilityFromAccount(facility: FacilitiesToAccount) {

        const editeParams = this.createAccountParams(facility, true);

        try {
            // there is no facility left in this canvasAccount doc
            if (editeParams.facilities.length === 0) {
                const response = await this.$lantern.endpoints.CanvasAccounts.remove(editeParams.canvasAccountId.toString());

            } else {
                const response = await this.$lantern.endpoints.CanvasAccounts.update(editeParams.canvasAccountId.toString(), { facilities: [...editeParams.facilities] });
            }
            await alert(`Records were updated successfully`);
            await this.getAccountFacilities();

        } catch (error) {
            await alert(`Error! Cannot create Lantern account record!`);
        }
    }
    // #endregion FACILITY TO ACCOUNT

    navigateTo(page: RouteNames) {
        this.$router.push(page);
    }

}
